import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { updateComment, fetchComments, deleteComment } from '../../actions';
import { monthNameDDYYYY } from '../date';

function Comment(props) {
  const [editing, setEditing] = useState(false);
  const [editTxt, setEditTxt] = useState('');
  const {
    comment, my, auth,
  } = props;

  // Show either edit or save button for user.
  const editButtonRender = () => {
    return (editing ? <i className="fas fa-check-circle" /> : <i className="fas fa-pencil-alt" />);
  };

  // Show either editable text or comment to owner.
  const editRender = () => {
    if (editing) {
      return <input className="comment-txt" value={editTxt} onChange={(e) => setEditTxt(e.target.value)} />;
    } else {
      return <p className="comment-txt">{comment.content}</p>;
    }
  };

  // Initiate async function to update comment, fetch comments when done.
  const sendUpdateComment = () => {
    if (!editing) {
      setEditTxt(comment.content);
      setEditing(true);
    } else {
      setEditing(false);
      updateComment(editTxt, comment.id).then(() => {
        props.fetchComments(comment.Page.id);
      }).catch((err) => {
        console.log(err);
      });
    }
  };

  // Initiate async function to delete comment, fetch comments when done.
  const sendDeleteComment = () => {
    deleteComment(comment.id).then(() => {
      props.fetchComments(comment.Page.id);
    }).catch((err) => {
      console.log(err);
    });
  };

  return (
    <div className="comment">
      <div className="comment-author">
        <img className="profile-pic-small" src={comment.Author.profpic} alt="" />
        <div className="author-and-date">
          <NavLink id="page-author-link" to={`/profile/${comment.Author.id}`}>
            {comment.Author.username}
          </NavLink>
          <p id="page-date">{monthNameDDYYYY(comment.createdAt)}</p>
        </div>
      </div>
      {editRender()}
      <div className={(!auth || comment.Author.id !== my.id) ? 'invisible' : 'comment-tools'}>
        <button onClick={sendDeleteComment} type="button" aria-label="trash"><i className="fas fa-trash" /></button>
        <button onClick={sendUpdateComment} type="button" aria-label="edit">{editButtonRender()}</button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => (
  {
    auth: state.auth.authenticated,
    my: state.author.current,
  }
);

export default connect(mapStateToProps, { fetchComments })(Comment);
